
import { times as npTimes,plus as npPlus, minus as npMinus } from 'number-precision';
export default {
  filters: {
    // Decoration Table：打印价格+附加价格
    multiplyPrice(a1, row, prop) {
      const rep = /^[0-9]+.?[0-9]*$/
      if (!rep.test(a1)) {
        return a1
      } else {
        return npTimes(a1, row.num)
      }
    },
    // Undecorated Table：基础价格+Decoration所选价格（包含附加价格）
    plusPrice(a1, a2) {
      return a2 ? npPlus(a1, a2) : a1
    },
    // Decoration Table：计算差价
    differencePrice(a1, row, prop, selectRow) {
      const rep = /^[0-9]+.?[0-9]*$/
      if (rep.test(a1)) {
        const temp = prop.split('_')

        const supplier = +row[`supplier_${temp[1]}`]
        const suppliers = npTimes(row.num - 1, supplier)
        const noIncludePrice = npPlus(a1, suppliers)

        const selSupplier = +selectRow[`supplier_${temp[1]}`]
        const selSuppliers = npTimes(selectRow.num - 1, selSupplier)
        const isIncludePrice = npPlus(+selectRow[prop], selSuppliers)

        return noIncludePrice > isIncludePrice
          ? `+${npMinus(noIncludePrice, isIncludePrice)}`
          : npMinus(noIncludePrice, isIncludePrice)
      } else {
        return a1
      }
    },
  },
  props: {
    hasDecAdd: {
      type: Number,
      default: 0,
    },
    tableData: {
      type: Array,
      default: () => {
        return []
      },
    },
    tableColumns: {
      type: Array,
      default: () => {
        return []
      },
    },
    operateWith: {
      type: String,
      default: '100%',
    },
    isCheckBox: {
      type: Boolean,
      default: false,
    },
    tableType: {
      type: String,
      default: 'Undecorated',
    },
    decorationObj: {
      type: Object,
      default: () => {
        return {}
      },
    },
    selectId: {
      type: Number,
      default: null
    },
    selectRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
    multipleSelection: {
      type: Array,
      default: () => {
        return []
      },
    },
    selectDecoration: {
      type: Object,
      default: () => {
        return {}
      },
    },
    curPrint: {
      type: String,
      default: '',
    },
    curModel: {
      type: String,
      default: '',
    },
    marginBottom: {
      type: Number,
      default: 20,
    },
    decorationMultiple: {
      type: Number,
      default: 1,
    },
    headerShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      setupConfigList: [
        { id: 1, name: '/col' },
        { id: 2, name: '/desgin' },
        { id: 3, name: '/pos' },
        { id: 4, name: '/pos desgin' },
        { id: 5, name: 'POA' },
        { id: 6, name: 'Waived' },
      ],
      setupTitleList: ['1st', '2nd', '3rd'],
    }
  },
  computed: {
    getTableContainerClass() {
      // 根据tableType的值返回不同的class
      return {
        'table-container': true,
        'border-Decoration': this.tableType === 'Decoration' && this.hasDecAdd
      };
    },
    comTitle() {
      if (this.tableType === 'Undecorated') {
        return `Includes ${this.curModel}`
      } else if (this.tableType === 'Decoration') {
        return `Add-Ons`
      } else {
        return this.curPrint
      }
    },
    comDisplayCss() {
      return this.tableType === 'Comparison' ? '1px solid #efefef' : 'none'
    },
    comMultipleSelID() {
      return this.multipleSelection.map(i => i.id)
    },
    comTableData() {
      if (this.tableType === 'Decoration') {
        return this.tableData
      } else {
        return this.tableData
      }
    },
  },
  mounted() {
    // 初始勾上默认选择打印项
    if (JSON.stringify(this.selectRow) !== '{}') {
      this.$refs.elTable.toggleRowSelection(this.selectRow)
    }
  },
  methods: {
    judgeProp(row, prop, $index) {
      if (
        $index === 0 && this.tableType === 'Decoration'
      ) {
        const temp = prop.split('_')
        return row[`supplier_${temp[1]}`]
      } else {
        return row[prop]
      }
    },
    $_setupPriceFilter(setupPriceID) {
      const result = this.setupConfigList.filter(
        item => item.id === setupPriceID
      )
      return result.length > 0 ? result[0].name : ''
    },
    isNumber(val) {
      const rep = /^[0-9]+.?[0-9]*$/
      return rep.test(val)
    },
    /* 暂不实现此功能
    //点击table栏时选中按钮
    handleCurrentChange(currentRow, oldCurrentRow) {
      this.$refs.elTable.clearSelection()
      this.$emit('update:selectId', currentRow.id)
      this.addCar(currentRow)
    },
    */
    // table全选
    handleSelectionChange(val) {
      this.$emit('update:multipleSelection', val)
    },
    dialogCheck(selection, row) {
      if (this.isCheckBox) return // 是多选框返回
      this.$refs.elTable.clearSelection()
      // 初始化
      if (selection.length === 0) {
        this.$emit('update:selectId', null)
        this.$emit('update:selectRow', {})
        return
      }
      if (row) {
        this.$emit('update:selectId', row.id)
        this.$emit('update:selectRow', row)
        this.$refs.elTable.toggleRowSelection(row, true)
      }
    },
    addCar(currentRow) {
      // 加入购物车需要parentId
      const selrow = Object.assign({}, currentRow)
      selrow.parentId = this.decorationObj.parentId
      this.$emit('update:selectRow', selrow)
      this.$refs.elTable.toggleRowSelection(currentRow)
    },
    getRowKey(row) {
      return row.id
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 隐藏'Decoration'选项框
      if (this.tableType === 'Decoration' && columnIndex === 0) {
        return [0, 1]
      }
      if (this.tableType === 'Decoration' && columnIndex === 1) {
        return [1, 2]
      }
    },
    tableRowClassName({ row }) {
      if (this.tableType === 'Decoration') {
        return this.decorationMultiple ? 'borderNone' : 'hiddenRow'
      }
      return 'fontBold'
    },
    handleSelectable(row, index) {
      // website_setup_id 5为POA，不可选
      return row.website_setup_id !== 5;
    },
    getNumber(e, row, max) {
        if (parseInt(e) > max) {
          row.num = max
        }
    }
  },
}
